// extracted by mini-css-extract-plugin
export default {"specialtyList":"ProgramClinicalSitesTable_specialtyList__Uu1+N","yearList":"ProgramClinicalSitesTable_yearList__Bhhh2"};